define('extensions/kendo.extensions',[], function() {

    var grid = {};

    // displays the column type field value using a culture specific format.
    grid.addColumnTemplateFormatters = function (columns) {        
        return _.map(columns, function (column) {
            column.type = column.type || "";
            column.type = column.type.toLowerCase();
            column.title = column.title === "" || column.title == null ? "&nbsp;" : column.title;
            column.width = column.width + "";
            column.width = column.width.indexOf("px") == -1 ? column.width + "px" : column.width;
            //column.width = typeof column.width == "string" ? (!isNaN(column.width) ? parseInt(column.width) : column.width) : column.width;
            column.operator = "contains";
            column.isInteger = false;
            column.isDecimal = false;
            column.isDate = false;
            column.isBoolean = false;
            
            switch (column.field) {
                //#region must not be filterable because of server side error
                case "docId": column.filterable = false; break;
                case "docDate": column.filterable = false; break;
                case "createdDate": column.filterable = false; break;
                case "sentDate": column.filterable = false; break;
                case "receivedDate": column.filterable = false; break;
                case "mailDate": column.filterable = false; break;
                case "lastModifiedDate": column.filterable = false; break;
                case "dispatchDate": column.filterable = false; break;
                case "checkedOutExpiry": column.filterable = false; break;
                case "checkedOutDate": column.filterable = false; break;
                case "amount": column.filterable = false; break;
                //#endregion
            }
            
            switch (column.type) {
                //#region reset properties
                case "date": {
                    //column.formatter = 'd';
                    //column.template = column.template || "#var field=" + column.field + "# #= field != null && kendo.toString(field,'d')!=kendo.toString(new Date('0001-01-01T00:00:00+00:00'),'d') ? kendo.toString(field,'" + column.formatter + "') : '' #";

                    column.format = '{0:d}';
                    column.type = "date";
                    column.operator = "equalto";
                    column.isDate = true;
                    break;
                }
                case "datetime": {
                    //column.formatter = 'g';
                    //column.template = column.template || "#var field=" + column.field + "# #= field != null && kendo.toString(field,'d')!=kendo.toString(new Date('0001-01-01T00:00:00+00:00'),'d') ? kendo.toString(field,'" + column.formatter + "') : '' #";

                    column.format = '{0:g}';
                    column.type = "date";
                    column.operator = "equalto";
                    column.isDate = true;
                    break;
                }
                case "integral": {
                    column.formatter = 'n0';
                    column.template = column.template || "#= kendo.toString(" + column.field + " == null ? '' : " + column.field + ",'" + column.formatter + "') #";
                    column.type = "number";
                    column.operator = "equalto";
                    column.isInteger = true;
                    break;
                }
                case "decimal": {
                    column.formatter = 'n';
                    column.template = column.template || "#= kendo.toString(" + column.field + " == null ? '' : " + column.field + ",'" + column.formatter + "') #";
                    column.type = "number";
                    column.operator = "equalto";
                    column.isDecimal = true;
                    break;
                }
                case "currency": {
                    column.formatter = 'c';
                    column.template = column.template || "#= kendo.toString(" + column.field + " == null ? '' : " + column.field + ",'" + column.formatter + "') #";
                    column.type = "number";
                    column.operator = "equalto";
                    column.isDecimal = true;
                    break;
                }
                case "percentage": {
                    column.formatter = 'p';
                    column.template = column.template || "#= kendo.toString(" + column.field + " == null ? '' : " + column.field + ",'" + column.formatter + "') #";
                    column.type = "number";
                    column.operator = "equalto";
                    column.isInteger = true;
                    break;
                }
                case "boolean": {
                    column.type = "bool";
                    column.operator = "equalto";
                    column.isBoolean = true;
                    break;
                }
                case "foreignkey": {
                    column.template = String.format("#if ({0}){# <ul>#for(var i = 0; i < {0}.length; i++){#<li>#:{0}[i].label #</li>#}#</ul>#}#", column.field);
                }
                //#endregion
            }                                  
            
            return column;
        });
    };

    //#region kendoGrid helper

    //This is a helper class that mostly just makes the telerik grid more keyboard friendly.

    grid.init = function (o) {
        /// <summary>
        ///Binds onSelect, keyboard navi, and databound row resselect
        ///Returns nothing.
        /// </summary>
        /// <param name="o" type="Dictionary">
        /// _grid: html grid, onSelect, onDblClick
        /// </param>

        var _grid = o.grid;
        var onSelect = o.onSelect;
        var onDblClick = o.onDblClick;
        var isShowActionMenu = o.isShowActionMenu;

        var kGrid = _grid.data('kendoGrid');

        //give rows tabindex, reselect row
        kGrid.bind('dataBound', function (e) {
            grid.onDataBound({ grid: _grid, onSelect: onSelect, isShowActionMenu: isShowActionMenu });
        });

        //bind arrows to navigate
        grid.bindNavigatable({ grid: _grid, isShowActionMenu: isShowActionMenu });

        //bind change event
        grid.bindChange({ grid: _grid, onSelect: onSelect, isShowActionMenu: isShowActionMenu });

        //bind dblclick
        if (onDblClick != undefined) {
            $('.k-grid-content tr', _grid)
                .live('dblclick', function (e) { //bind row dblclick
                    var id = _grid.data('kendoGrid').dataItem(e.currentTarget).id;
                    onDblClick(id);
                });
        }

    };

    grid.bindNavigatable = function (o) {

        var _grid = o.grid;
        var isShowActionMenu = o.isShowActionMenu;

        var target = $('.k-grid-content', _grid);
        //give it a tabindex so it can get focus and accept key input.
        target.attr("tabindex", 0);

        //Detecting when the scrollbar is clicked to prevent the focus event from firing and scrolling back up/down.
        target.mousedown(function (e) {
            var innerWidth = target.find('table').first().width();
            if (e.offsetX > innerWidth)
                e.preventDefault();
        });

        //This allows a diff background color for a selected row based on whether the grid has focus or not.
        target.focus(function (e) {
            var selRow = _grid.find('.k-state-selected');
            if (selRow.length) {
                selRow.focus();
            }
        });

        target.keydown(function (ke) {
            
            //override scroll bar so arrows will navigate rows without scrolling.
            ke.preventDefault();

            var kGrid, curRow, newRow;

            kGrid = $(this).closest('.k-grid').data("kendoGrid");

            //get currently selected row
            curRow = kGrid.select();
            
            //abort if no row selected
            if (!curRow.length)
                return;
            
            //get newRow up or down.
            if (ke.which == 38) {
                newRow = curRow.prev();
            } else if (ke.which == 40) {                
                newRow = curRow.next();
                if (isShowActionMenu)
                    newRow = newRow.next();
            } else {
                return;
            }
            
            //Top or Bottom exceeded, abort.
            if (!newRow.length) {
                var vs = $(this).closest('.k-grid').find('.k-scrollbar-vertical');
                var s = 150;

                s = ke.which == 38 ? -s : s;
                s = ke.which == 40 ? +s : s;

                vs.scrollTop(vs.scrollTop() + (s * 2));

                return;
            }

            kGrid.select(newRow);           
            
            newRow.focus();            
        });

    };

    grid.bindChange = function (o) {
        var _grid = o.grid;
        var onSelect = o.onSelect;
        var isShowActionMenu = o.isShowActionMenu;

        var kGrid = _grid.data('kendoGrid');

        kGrid.bind('change', function (e) {
            //This fixes the problem of losing focus on auto-refresh
            if (document.activeElement == document.body)
                kGrid.select().focus();

            //When using Kendo grid mvc wrapper, the datasource is not set, so accessing dataItem will fail.
            if (!kGrid.dataSource.data().length)
                return;
            
            //Set _grid.selectedId, and execute onSelect
            var $row = kGrid.select();

            if ($row.find("#results-action-bar").length > 0) {

                $row.removeClass("k-state-selected");
                $row.prev().addClass("k-state-selected");

                return;
            }

            var rowIndex = $row.index();
            var $mnu = kGrid.table.find("tr[data-uid='00000000-0000-0000-0000-000000000000']");
            var mnuIndex = $mnu.index();

            if (mnuIndex != -1) {
                if (rowIndex > mnuIndex)
                    rowIndex = rowIndex - 1;
            }

            var dataItem = kGrid.dataSource.data()[rowIndex]; //kGrid.dataItem($row);
            if (dataItem == null || !dataItem.id || dataItem.id == null)
                return;

            //if (dataItem.id != kGrid.selectedId && onSelect != undefined) {
            if (onSelect != undefined) {
                if (isShowActionMenu) {
                    sessionStorage.__mnuact__ = 1;
                    showActionMenu($row, e.sender, dataItem.uid, (dataItem.documentClass && dataItem.documentClass == 1), (dataItem.isReadOnly));
                    sessionStorage.__mnuact__ = 0;
                }

                kGrid.selectedId = dataItem.id;

                onSelect(dataItem.id);
            }
        });
    };

    //Mostly this function just takes care of reselecting the global kGrid.selectedId. 
    //Before I tried to not use a global, and call refresh with an id, but the problem is that
    //other things call a data fetch like sorting, paging, manual refresh, and I have no way of sending the id with them.
    //So a global flag, autoRefresh is used to denote when to call the onSelect method or not.  Calling onSelect while
    //in autoRefresh mode would be bad since it would interrupt other UI stuff going on.
    grid.onDataBound = function (o) {
        /// <summary>
        ///Binds databound row resselect
        ///Returns nothing.
        /// </summary>
        /// <param name="o" type="Dictionary">
        /// grid: html grid, onSelect
        /// </param>
        var _grid = o.grid;
        var onSelect = o.onSelect;
        var isShowActionMenu = o.isShowActionMenu;

        var kGrid = _grid.data('kendoGrid');

        //give rows a tabindex so focus will work
        kGrid.content.find('tr').attr('tabindex', 0);

        //Reselect saved row by grid.selectedId
        if (kGrid.selectedId != undefined) {
            var dataItem = kGrid.dataSource.get(kGrid.selectedId);
            if (dataItem != undefined) {
                var $row = kGrid.table.find("tr[data-uid='" + dataItem.uid + "']");
                if ($row.length) {
                    
                    kGrid.select($row);                    

                    //call onSelect method since change event will ignore it since the selectedId has not changed.
                    if (!kGrid.autoRefresh && onSelect != undefined) {
                        if (isShowActionMenu) {                            
                            sessionStorage.__mnuact__ = 1;
                            showActionMenu($row, kGrid, dataItem.uid, (dataItem.documentClass && dataItem.documentClass == 1), (dataItem.isReadOnly));
                            sessionStorage.__mnuact__ = 0;
                        }

                        onSelect(kGrid.selectedId);
                    }
                }
            }
        }
        
        //select first row if nothing else selected
        //if (!kGrid.select().length && kGrid.table.find('tr').length) {
        //    kGrid.select(kGrid.table.find('tr').first());
        //}

        kGrid.autoRefresh = false;
    };

    //#endregion

    return {
        grid: grid
    };

    function showActionMenu($row, grid, parentUid, isEmail, isControlledAndReadOnly) {
        var $actionMenu = $("#results-action-bar-clone").clone(true, true);
        if (isEmail) {
            $actionMenu.find("#result-grid-action-bar-open-c").hide();
            $actionMenu.find("#result-grid-action-bar-new").hide();

            //hide for now
            $actionMenu.find("#result-grid-action-bar-reply").hide();
            $actionMenu.find("#result-grid-action-bar-forward").hide();
        } else {
            $actionMenu.find("#result-grid-action-bar-reply").hide();
            $actionMenu.find("#result-grid-action-bar-forward").hide();
        }
        if (isControlledAndReadOnly) {
            $actionMenu.find("#result-grid-action-bar-open-c").hide();
        }

        $actionMenu.attr('id', 'results-action-bar'); $actionMenu.show();

        var $newmnu = $('<tr data-uid="00000000-0000-0000-0000-000000000000" role="row"><td colspan="' + grid.columns.length + '" style="padding:0;line-height:45px;background-color:#f5f5f5"><div></div></td></tr>'); $newmnu.find("td[colspan='" + grid.columns.length + "'] div").replaceWith($actionMenu);
        var $mnu = grid.table.find("tr[data-uid='00000000-0000-0000-0000-000000000000']");

        var mnuIndex = $mnu.index();
        var rowIndex = $row.index();

        if ($mnu.length > 0) {
            $mnu.remove();
            //grid.refresh();
        }

        //grid.table.find('tr[data-uid="' + $row.attr("data-uid") + '"]').eq(to).after($newmnu);
        $row = grid.table.find('tr[data-uid="' + $row.attr("data-uid") + '"]');

        if (mnuIndex < rowIndex) {
            $row.next().removeClass("k-state-selected");
            $row.addClass("k-state-selected");
        }

        $row.after($newmnu);

        //if (rowIndex == grid.dataSource.data().length - 1) {
        //    //grid.table.find("tr").first().next().hide();
        //    //grid.table.find("tr").first().hide();
        //    console.warn("to last row");
        //    $row.before($newmnu);
        //} else {
        //    //grid.table.find("tr").first().show();
        //    //grid.table.find("tr").first().next().show();
        //    $row.after($newmnu);
        //}


        //#region createActionRow
        //function createActionRow(columns, _prowuid) {
        //    var row = {};

        //    _.map(columns, function (itm) {
        //        row[itm.field] = '';
        //    });

        //    row.documentId = null;
        //    row._prowuid = _prowuid;
        //    row.icon = "";
        //    row.isFavourite = false;
        //    row.isFlagged = false;
        //    row.checked = false;
        //    row.documentClass = "";

        //    return row;
        //}
        //#endregion
    }
});
